export class GasLiftValve {
    public constructor(init?: Partial<GasLiftValve>) {
        Object.assign(this, init);
    }

    id: string;
    designId: string;
    name: string;
    measuredDepth: number;
}